Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var styles = _reactNative.StyleSheet.create({
    container: {
      flexGrow: 1,
      width: '100%',
      maxWidth: _styles.STYLES.grid.maxInputWidth
    },
    label: {
      marginBottom: spacing.normal
    }
  });
  return {
    styles: styles
  };
};